import React, { Component } from 'react';

import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';
import CurrencyInput from 'react-currency-input';

import {
    Row,
    Col,
    Spin,
    Select,
    Form,
    Input,
    Checkbox,
    Button,
    Modal,
    Alert 
} from 'antd';
import MaskedInput from 'react-maskedinput';
import './CartaoCredito.css'

const FormItem = Form.Item;
const Option = Select.Option;

class CartaoCredito extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            buscando: false,
            obCartaoCredito:{},
            cartaoBandeiras: []
        }        

        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
        this.usuario = this.dadosProvider.getDadosUsuario();
    }

    componentWillMount() {
        this.getTipoCartaoBandeira();
        this.getCartaoCredito();
    }

    getCartaoCredito(){
        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.usuario.Cripto,
            "dsEmail": "",
            "cdTipoOrigem": 5
        };

        this.setState({ buscando: true });

        this.dataService.ListaCartaoCredito(dados, (retorno) => {
           
            this.setState({ buscando: false });

            if (retorno.length > 0) {
                this.setState({ obCartaoCredito: retorno[0]});

                if (this.state.obCartaoCredito["CdStatus"] === "27") {
                    this.abreFormConfirmaCartao();    
                }
            }
        }, (erro) => {
            console.log(erro);
            this.setState({ buscando: false });
        });
    }

    getTipoCartaoBandeira(){        

        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.usuario.Cripto,
            "dsEmail": "",
            "cdTipoOrigem": 5
        };

        // this.setState({ buscando: true });

        this.dataService.ListaCartaoCreditoBandeira(dados, (retorno) => {
            if (retorno.length > 0) {
                // this.setState({ buscando: false });
                this.setState({ cartaoBandeiras: retorno});
            }

        }, (erro) => {
            console.error(erro);
            // this.setState({ buscando: false });
        });
    }

    setCartaoCredito(values){
        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.usuario.Cripto,
            "dsEmail": values.dsEmail,
            "cdTipoOrigem": 5,
            "nrCartao": values.nrCartao.replace(/[ ]/g, ""),
            "dsNomeTitulo": values.dsNomeTitulo,
            "nrCPF": values.nrCPF.replace(/[.-]/g,""),
            "nrCep": values.nrCep,
            "nrValidadeMes": values.dtValidade.substr(0, 2),
            "nrValidadeAno": values.dtValidade.substr(3, 2),
            "nrCodigoSeguranca": values.nrCodigoSeguranca,
            "cdTipoCartaoBandeira": values.cdTipoCartaoBandeira,
            "nrTelefone": values.nrTelefone
        };

        console.log(JSON.stringify(dados));

        this.setState({ loading: true });

        this.dataService.SalvaCartaoCredito(dados, (retorno) => {

           this.setState({ loading: false });

            if (retorno.Status === "1") {
                Modal.success({
                    title: 'Sucesso',
                    content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />)                    
                });

                this.getCartaoCredito();

            }else if (retorno.Status === "27") {
                this.getCartaoCredito();
            }else {
                Modal.error({
                    title: 'Erro',
                    content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />)
                });
            }
        }, (erro) => {
            console.error(erro);
            this.setState({ loading: false });
        });
    }

    apagarCartaoCredito(){
        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.usuario.Cripto,
            "cdPessoaCartaoCredito": this.state.obCartaoCredito.CdPessoaCartaoCredito,
            "cdTipoOrigem": 5
        };

        this.setState({ loading: true });

        this.dataService.ApagarCartaoCredito(dados, (retorno) => {

           this.setState({ loading: false });

            if (retorno.Status === "1") {
                Modal.success({
                    title: 'Sucesso',
                    content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />)                    
                });

                this.setState({ obCartaoCredito: {} });

            } else {
                Modal.error({
                    title: 'Erro',
                    content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />)
                });
            }
        }, (erro) => {
            console.error(erro);
            this.setState({ loading: false });
        });
    }

    confirmaCartao(vlConfirmacaoCartao){
        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.usuario.Cripto,
            "cdPessoaCartaoCredito": this.state.obCartaoCredito["CdPessoaCartaoCredito"],
            "vlConfirmacaoCartao": vlConfirmacaoCartao,
            "cdTipoOrigem": 5
        };

        this.setState({ loading: true });

        this.dataService.ConfirmaCartao(dados, (retorno) => {

           this.setState({ loading: false });

            if (retorno.Status === "1") {
                Modal.success({
                    title: 'Sucesso',
                    content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />)                    
                });

                this.setState({ obCartaoCredito: {} });

                this.getCartaoCredito();

            } else {
                Modal.error({
                    title: 'Erro',
                    content:(<div dangerouslySetInnerHTML={{ __html: this.htmlDecode(retorno.Msg) }} />),
                    onOk: ()=>{this.abreFormConfirmaCartao()}
                });
            }
        }, (erro) => {
            console.error(erro);
            this.setState({ loading: false });
        });
    }

    abreFormConfirmaCartao(){
        this.setState({ buscando: false });
        var _this = this;

        Modal.confirm({
            title: 'Foi realizado um débito em seu cartão de crédito, para terminar o cadastro digite o valor cobrado:',
            content:(
                this.getFormConfirmaCartao()
            ),
            okText: "Enviar",
            onOk: ()=>{
                var vl = _this.props.form.getFieldValue("vlConfirmacaoCartao");
                vl = vl.replace("R$ ", "");
                vl = vl.replace(`${this.usuario.DsMoedaPadrao} `, "");
                this.confirmaCartao(vl);
            }
        });  
    }

    getFormConfirmaCartao(){
        const { getFieldDecorator } = this.props.form;

        return(
            <Form name="formConfirmaCartao" className="formConfirmaCartao">
                {this.state.buscando ?
                    (<Row>
                        <Col className="imageRadio">
                            <div className="divSpin">
                                <Spin className="imageSpin" />
                            </div>
                        </Col>
                    </Row>) 
                    : 
                
                (
                    <div>
                        <Row gutter={8}>
                            <Col span={24}>
                                <FormItem
                                    label="">
                                    {getFieldDecorator('vlConfirmacaoCartao', {
                                        rules: [{
                                            required: true, message: 'Insira o número debitado de sua fatura',
                                        }],
                                    })(
                                        <CurrencyInput className="ant-input" prefix={this.usuario.DsMoedaPadrao+" "} name="vlConfirmaCartao" decimalSeparator="," thousandSeparator="."/>
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </div>
                )}
            </Form>
        );
    }

    getFormListaCartao(getFieldDecorator){
        return (

            <div>
                <Row gutter={8}>
                    <Col span={14}>
                        <FormItem
                            label="Nº Cartão">
                            {getFieldDecorator('nrCartaoTruncado', {
                                initialValue: this.state.obCartaoCredito["NrCartaoTruncado"]
                            })(
                                <Input disabled/>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={10}>
                        <FormItem
                            label="Bandeira">
                            {getFieldDecorator('dsTipoCartaoBandeira', {
                                initialValue: this.state.obCartaoCredito["DsTipoCartaoBandeira"]
                            })(
                                <Input disabled/>
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={8}>
                    <Col span={12}>
                        <FormItem
                            label="Nome do Titular">
                            {getFieldDecorator('dsNomeTitulo_lista', {
                                initialValue: this.state.obCartaoCredito["DsNomeTitulo"]
                            })(
                                <Input disabled/>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem
                            label="CPF">
                            {getFieldDecorator('nrCPF_lista', {
                                initialValue: this.state.obCartaoCredito["NrCPF"]
                            })(
                                <MaskedInput className="ant-input" mask="111.111.111-11" size="20" disabled></MaskedInput>
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row gutter={8}>
                    <Col span={12}>
                        <FormItem
                            label="Validade">
                            {getFieldDecorator('dtValidade_lista', {
                                initialValue: this.state.obCartaoCredito["NrValidadeMes"]+"/"+this.state.obCartaoCredito["NrValidadeAno"]
                            })(
                                <Input disabled/>
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </div>
        );
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ erro: false });  

        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setCartaoCredito(values);                
            }
        });
    }

    handleConfirmaCartao = (e) => {
        e.preventDefault();

        this.setState({ erro: false });  

        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.confirmaCartao(values);                
            }
        });
    }


    htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }

    render(){
        const { getFieldDecorator } = this.props.form;

        return(
            <Form onSubmit={this.handleSubmit} className="formCartaoCredito">
                {this.state.buscando ?
                    (<Row>
                        <Col className="imageRadio">
                            <div className="divSpin">
                                <Spin className="imageSpin" />
                            </div>
                        </Col>
                    </Row>) 
                    : 
                
                (
                    <div>
                        {JSON.stringify(this.state.obCartaoCredito) == "{}" ? (
                            <div>
                                <Row gutter={8}>
                                    <Col span={14}>
                                        <FormItem
                                            label="Nº Cartão">
                                            {getFieldDecorator('nrCartao', {
                                                rules: [{
                                                    required: true, message: 'Insira o número do cartão',
                                                }],
                                            })(
                                                <MaskedInput className="ant-input" mask="1111 1111 1111 1111" size="20"></MaskedInput>
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={10}>
                                        <FormItem
                                            label="Bandeira">
                                            {getFieldDecorator('cdTipoCartaoBandeira', {
                                                rules: [{
                                                    required: true, message: 'Preencha a bandeira do seu cartão',
                                                }]
                                            })(
                                                <Select>
                                                    {this.state.cartaoBandeiras.map(bandeira => <Option key={bandeira["CdTipoCartaoBandeira"]}>{bandeira["DsTipoCartaoBandeira"]}</Option>)}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={12}>
                                        <FormItem
                                            label="Nome do Titular">
                                            {getFieldDecorator('dsNomeTitulo', {
                                                rules: [{
                                                    required: true, message: 'Insira o nome do titular',
                                                }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem
                                            label="Telefone">
                                            {getFieldDecorator('nrTelefone', {
                                                rules: [{
                                                    required: true, message: 'Digite o seu telefone', max: 12
                                                }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <FormItem
                                            label="E-mail">
                                            {getFieldDecorator('dsEmail', {
                                                rules: [{
                                                    required: true, message: 'Digite um e-mail válido',
                                                }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={12}>
                                        <FormItem
                                            label="CPF">
                                            {getFieldDecorator('nrCPF', {
                                                rules: [{
                                                    required: true, message: 'Insira um CPF válido',
                                                }],
                                            })(
                                                <MaskedInput className="ant-input" mask="111.111.111-11" size="20"></MaskedInput>
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem
                                            label="CEP">
                                            {getFieldDecorator('nrCep', {
                                                rules: [{
                                                    required: true, message: 'Insira um CEP válido',
                                                    max: 8
                                                }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={12}>
                                        <FormItem
                                            label="Validade">
                                            {getFieldDecorator('dtValidade', {
                                                rules: [{
                                                    required: true, message: 'Insira a data de validade',
                                                }],
                                            })(
                                                <MaskedInput className="ant-input" mask="11/11" size="5"></MaskedInput>
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem
                                            label="CVV">
                                            {getFieldDecorator('nrCodigoSeguranca', {
                                                rules: [{
                                                    required: true, message: 'Insira um CVV válido', max: 3
                                                }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row> 
                            </div>
                        ):(
                            this.getFormListaCartao(getFieldDecorator)
                        )}                       
                        <Row>
                            {JSON.stringify(this.state.obCartaoCredito) == "{}" ? (
                                <Col span={24}>
                                    <FormItem>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            className="login-form-button"
                                            loading={this.state.loading}>
                                            Salvar
                                        </Button>
                                    </FormItem>
                                </Col>
                            ) : (
                                <Col span={24}>
                                    <FormItem>
                                        <Button
                                            type="danger"
                                            htmlType="button"
                                            className="login-form-button"
                                            loading={this.state.loading}
                                            onClick={()=>this.apagarCartaoCredito()}>
                                            Remover
                                        </Button>
                                    </FormItem>
                                    {this.state.obCartaoCredito["CdStatus"] === "27" ? (
                                        <FormItem>
                                            <Button
                                                type="primary"
                                                htmlType="button"
                                                className="login-form-button"
                                                loading={this.state.loading}
                                                onClick={()=>this.abreFormConfirmaCartao()}>
                                                Validar
                                            </Button>
                                        </FormItem>
                                    ) : (<div></div>)}
                                </Col>
                            )}
                        </Row>
                    </div>
                )}
            </Form>
        )
    }
}

export default Form.create()(CartaoCredito);


// WEBPACK FOOTER //
// ./src/Components/CartaoCredito/CartaoCredito.js